import { render, staticRenderFns } from "./menu-club.vue?vue&type=template&id=363e2c3a&scoped=true&"
import script from "./menu-club.vue?vue&type=script&lang=js&"
export * from "./menu-club.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363e2c3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Vuejs-Project\\subsappadminOrg\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('363e2c3a')) {
      api.createRecord('363e2c3a', component.options)
    } else {
      api.reload('363e2c3a', component.options)
    }
    module.hot.accept("./menu-club.vue?vue&type=template&id=363e2c3a&scoped=true&", function () {
      api.rerender('363e2c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/menus/menu-club.vue"
export default component.exports